export const getTrentinHautAdigeData = () => ({
  name: "Trentin-Haut-Adige",
  country: "Italie",
  description: "Le Trentin-Haut-Adige est une région viticole alpine du nord de l'Italie, produisant des vins blancs élégants et des vins rouges de qualité dans un environnement montagneux unique.",
  type: "region",
  subregions: [
    { name: "Alto Adige", area: "5,300 ha", percentage: "65%", description: "Vins blancs de montagne" },
    { name: "Trentino", area: "2,800 ha", percentage: "35%", description: "Vins rouges et blancs" }
  ],
  mapAreas: [
    { region: "Alto Adige", x: 11.5, y: 46.5, color: "#4B164C", size: 6 },
    { region: "Trentino", x: 11.0, y: 46.0, color: "#6d2c7a", size: 5 }
  ],
  statistics: {
    totalArea: "8,100 ha",
    production: "800,000 hectolitres",
    wineries: "200+ domaines",
    appellations: "2 sous-régions",
    exportPercentage: "40%"
  },
  characteristics: {
    climate: "Climat alpin avec de grandes amplitudes thermiques",
    soil: "Sols granitiques, calcaires et morainiques",
    viticulture: "Vignes en altitude (200-1,000m), vendanges manuelles"
  },
  wineStyles: {
    red: "Vins rouges élégants et structurés, avec des tannins fins",
    white: "Vins blancs frais et aromatiques, avec une acidité vive",
    rosé: "Rosés fruités et frais"
  },
  history: "La viticulture dans le Trentin-Haut-Adige remonte à l'époque romaine. La région a développé une tradition viticole unique, influencée par les cultures italienne et autrichienne.",
  foodPairing: "Cuisine alpine traditionnelle, fromages de montagne, charcuteries locales"
}); 